import React, { FC } from 'react';
import { DatePicker, FlexGroup, FlexItem } from '.';

interface DatePickerRangeProps {
  start: Date | undefined | null;
  setStart: (_: Date | null | undefined) => void;
  end: Date | undefined | null;
  setEnd: (_: Date | null | undefined) => void;
  minDate?: Date;
  maxDate?: Date;
  title?: React.ReactNode;
  allowTimeSelection?: boolean;
  minLabel?: React.ReactNode;
  maxLabel?: React.ReactNode;
}

const DatePickerRange: FC<DatePickerRangeProps> = ({
  start,
  setStart,
  end,
  setEnd,
  minDate,
  maxDate,
  title,
  allowTimeSelection,
  minLabel,
  maxLabel,
}) => {
  return (
    <FlexGroup padding="0" gapSize="2" alignItems="center" justifyContent="flex-start">
      <FlexItem grow={0}>
        <DatePicker
          currentDate={start}
          setCurrentDate={setStart}
          maxDate={end ? end : new Date()}
          minDate={minDate}
          title={title}
          allowTimeSelection={allowTimeSelection}
          label={minLabel}
        />
      </FlexItem>
      <FlexItem grow={0}>
        <FlexGroup padding="0" alignItems="center" direction="column">
          &mdash;
        </FlexGroup>
      </FlexItem>
      <FlexItem grow={0}>
        <DatePicker
          currentDate={end}
          setCurrentDate={setEnd}
          minDate={start ? start : new Date(0)}
          maxDate={maxDate}
          title={title}
          allowTimeSelection={allowTimeSelection}
          label={maxLabel}
        />
      </FlexItem>
    </FlexGroup>
  );
};

export default DatePickerRange;
